interface LoginRequiredConfirmProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function LoginRequiredConfirm({
  open,
  title = '需要登录后访问',
  description = '该功能需要登录后才能访问，是否前往登录页面？',
  confirmText = '去登录',
  cancelText = '取消',
  onConfirm,
  onCancel,
}: LoginRequiredConfirmProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[400] bg-black/45 flex items-center justify-center p-4"
    >
      <div
        className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-[#0ea5e9]/10 flex items-center justify-center">
          <i className="ri-user-shared-line text-[#0ea5e9] text-2xl"></i>
        </div>
        <h3 className="text-center text-base font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-center text-sm text-gray-500 leading-relaxed mb-5">{description}</p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-2.5 border border-gray-200 text-gray-600 text-sm font-medium rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 py-2.5 bg-[#0ea5e9] text-white text-sm font-medium rounded-xl hover:bg-[#0284c7] cursor-pointer whitespace-nowrap"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
